import logoUrl from '~/assets/common/logo256.png';
import qrcodeUrl from '~/assets/common/QYQrcode.jpg';

export const DefaultQrCodeUrl = qrcodeUrl;
export const DefaultLogoUrl = logoUrl;

// 功能名称 智剪
export const DEFAULT_FUNCTION_NAME = '智剪';

// 客服电话1 2
export const DEFAULT_CUSTOMER_SERVICE_PHONE = '16620803786';
export const DEFAULT_CUSTOMER_SERVICE_PHONE2 = '19223559211';

// 邮箱地址1 2
export const DEFAULT_EMAIL = 'taohongmin@sina.cn';
export const DEFAULT_EMAIL2 = 'taohongmin51@gmail.com';

export const THEME_COLOR = '#5c89ff'; // --primary-light

// 小屏自适应分界线（移动设备）
export const ScreenBreakpoint = 992; // 自定义断点

export const G_EmptyStr = '-';

// 申请试用地址
export const G_TrialUrl = 'https://live.gogoshine.com';
